import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PlusCircle, Loader2 } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import { Card, CardContent, CardHeader, CardTitle } from "../../Components/StakingRisk/ui/card";
import { CreateStakingRiskThunk } from "../../Store/Thunks/StakingRiskThunk";
import { Button } from "../../Components/StakingRisk/ui/button";
import { Input } from "../../Components/StakingRisk/ui/input";

export default function CreateProduct() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [error, setError] = useState("");  
  const [isCreating, setIsCreating] = useState(false);
  const [productName, setProductName] = useState("");

  const productId = useSelector((state) => state.StakingRiskReducer.createdStakingRiskId);

    useEffect(() => {
    if (productId !== 0) {
      navigate(`/stakingrisk/product-detail/${productId}`);
    }
  }, [productId, navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!productName.trim()) {
      setError("Product name is required");
      return;
    }
     dispatch(CreateStakingRiskThunk(productName))
    setIsCreating(true);
    };

  return (
    <div className="p-6 max-w-7xl mx-auto flex items-center justify-center min-h-[calc(100vh-8rem)]">
      <Card className="w-full max-w-md border-none shadow-lg">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold text-gray-900 dark:text-white">Create New Staking Product</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="product-name" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Product Name
              </label>
              <Input
                id="product-name"
                placeholder="Enter staking product name"
                value={productName}
                onChange={(e) => {
                  setProductName(e.target.value);
                  setError("");
                }}
                className={error ? "border-red-500" : ""}
                autoFocus
              />
              {error && <p className="text-sm text-red-500">{error}</p>}
            </div>
            
            <Button 
              type="submit" 
              className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              disabled={isCreating}
            >
              {isCreating ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Creating...
                </>
              ) : (
                <>
                  <PlusCircle className="mr-2 h-4 w-4" />
                  Create Product
                </>
              )}
            </Button>
            
            <div className="flex justify-center">
              <Button 
                type="button" 
                variant="ghost" 
                onClick={() => navigate("/stakingrisk/dashboard")}
                disabled={isCreating}
              >
                Cancel
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}